import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { type ReactNodeViewProps, NodeViewContent } from '@tiptap/react';

const ShortAnswerHintNodeView: React.FC<ReactNodeViewProps> = ({ decorations }) => {
    return (
        <ZyNodeViewWrapper
            decorations={decorations}
            className="mt-2 w-full rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 p-3 dark:border-gray-600 dark:bg-gray-950/20"
        >
            <span
                className="text-sm font-semibold text-gray-700 dark:text-gray-400"
                contentEditable={false}
            >
                Hint:
            </span>
            <NodeViewContent className="text-gray-900 dark:text-gray-200" />
        </ZyNodeViewWrapper>
    );
};

export default ShortAnswerHintNodeView;
